import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Divider,
  Form,
  Input,
  message,
  Card,
  Row,
  Spin,
  Modal,
} from "antd";
import {
  EyeInvisibleOutlined,
  EyeTwoTone,
  LoadingOutlined,
  ToolOutlined,
  SettingOutlined,
} from "@ant-design/icons";
import {
  authProject,
  authUser,
  getDns,
  getDataAccountCard,
  setItem,
  removeItem,
  getItem,
} from "utils";

import {
  getAllCSSVariableNames,
  getElementCSSVariables,
} from "../../utils/stylesheet";

import ReCAPTCHA from "react-google-recaptcha";

import history from "../../services/history";
import { authConfig, applyStyles } from "../../utils/auth";

import logoWhite from "../../assets/img/logo-white.png";
import img from "../../assets/img/img-18.png";

export default function UnderMaintenance() {
  return (
    <div className="__auth-under-maintenance">
      <div className="container d-flex flex-column justify-content-center h-100">
        <Row justify="center">
          <Col xs={20} sm={20} md={20} lg={9}>
            <Card>
              <div className="my-2">
                <div className="text-center">
                  <div className="main-logo" style={{ height: "40px" }}></div>
                  <div style={{ marginTop: "50px" }}>
                    <SettingOutlined
                      style={{ fontSize: "40px", color: "#7e7e7e" }}
                      className="__auth-icon-maintenance"
                    />
                  </div>
                  <div style={{ margin: "20px" }}>
                    <p className="mb-4" style={{ fontSize: "18px" }}>
                      Estamos em manutenção para melhoria dos nossos serviços,
                      tente novamente mais tarde.
                    </p>
                  </div>
                </div>
              </div>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
}
